<template></template>

<script>
    export default {
        name: "CardLimitMixin",
        methods: {
            getCardsLoadOption () {
                return this.myData.cardsLoadOption;
            },
            getCardsPerPage () {
                return this.myData.cardsPerRow;
            },
            setCardsLoadOption (eventData) {
                this.changeMyData({
                    cardsLoadOption: eventData.value,
                    limitAmountOfCards: eventData.value !== 'load-all-cards'
                });
                this.setChangesAreSaved(false);
            },
            setCardsPerPage (eventData) {
                this.changeMyData({cardsPerRow:eventData.value});
                this.setChangesAreSaved(false);
            },
        }
    }
</script>

